export default __webpack_public_path__ + "static/media/sad-icon.1bcc3a20.svg";